import { tv, VariantProps } from 'tailwind-variants';

const notificationBannerVariants = tv({
  slots: {
    container: 'flex items-center gap-3 px-3 py-2.5 rounded-lg border animate-fadeIn',
    text: 'text-xs flex-1',
    icon: 'flex-shrink-0',
    dismissButton: 'transition-colors cursor-pointer bg-transparent border-none outline-none focus:outline-none p-0.5',
  },
  variants: {
    variant: {
      prompt: {
        container: 'bg-blue-50 border-blue-200',
        text: 'text-blue-800',
        icon: 'text-blue-600',
        dismissButton: 'text-blue-400 hover:text-blue-600',
      },
      waiting: {
        container: 'bg-amber-50 border-amber-200',
        text: 'text-amber-800',
        icon: 'text-amber-600',
        dismissButton: 'text-amber-400 hover:text-amber-600',
      },
      granted: {
        container: 'bg-green-50 border-green-200',
        text: 'text-green-800',
        icon: 'text-green-600',
        dismissButton: 'text-green-400 hover:text-green-600',
      },
      denied: {
        container: 'bg-red-50 border-red-200',
        text: 'text-red-800',
        icon: 'text-red-500',
        dismissButton: 'text-red-400 hover:text-red-600',
      },
    },
  },
  defaultVariants: {
    variant: 'prompt',
  },
});

type NotificationBannerVariant = VariantProps<typeof notificationBannerVariants>['variant'];

export { notificationBannerVariants };
export type { NotificationBannerVariant };
